module.exports = __webpack_public_path__ + "static/media/nutrition-score-bg.cc1bb82b.png";